export default __webpack_public_path__ + "static/media/presentation-2.04f89e4e.png";